import { render } from "./IconItemCategoryBook.vue?vue&type=template&id=4865e574"
import script from "./IconItemCategoryBook.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__